import { render } from "./Sellings.vue?vue&type=template&id=72d6814d"
import script from "./Sellings.vue?vue&type=script&lang=js"
export * from "./Sellings.vue?vue&type=script&lang=js"

import "./Sellings.vue?vue&type=style&index=0&id=72d6814d&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__